export const REQUEST_ERROR_MESSAGE = 'Ошибка сервера';

export const FORM_NAME = 'specify-flight';

export const REQUIRED_FIELDS = ['flight'];
